import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonIconModule } from '@impairedShared/button-icon/button-icon.module';
import { TranslateModule } from '@ngx-translate/core';
import { MultiSelectModule } from '@shared/components/multi-select/multi-select.module';
import { ImpairedIconModule } from '@impairedShared/impaired-icon/impaired-icon.module';
import { NgLetModule } from '@shared/directives/ng-let/ng-let.module';
import { ImpairedBackwardBtnModule } from '@impairedShared/impaired-backward-btn/impaired-backward-btn.module';
import { TableComponent } from './components/table/table.component';
import { TableFilterComponent } from './components/table-filter/table-filter.component';
import { RoutingModule } from './routing.module';
import { MainComponent } from './components/main/main.component';
import { AppCardComponent } from './components/app-card/app-card.component';

@NgModule({
  declarations: [MainComponent, TableFilterComponent, TableComponent, AppCardComponent],
  imports: [
    CommonModule,
    RoutingModule,
    ButtonIconModule,
    TranslateModule,
    MultiSelectModule,
    ImpairedIconModule,
    NgLetModule,
    ImpairedBackwardBtnModule
  ]
})
export class AppsModule {}
